import { render } from "./MindMap.vue?vue&type=template&id=5a2ca92e&scoped=true"
import script from "./MindMap.vue?vue&type=script&lang=js"
export * from "./MindMap.vue?vue&type=script&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=5a2ca92e&lang=less"
import "./MindMap.vue?vue&type=style&index=1&id=5a2ca92e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2ca92e"]])

export default __exports__